import React from 'react';

interface SVGComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  size?: number[];
}

const SVGComponent: React.FC<SVGComponentProps> = ({
  primaryColor = '#EB6029',
  secondaryColor = '#074E69',
  size = [39, 39]
}) => {
  return (
    <div>
      <svg
        width={size[0]}
        height={size[1]}
        viewBox="0 0 100 100"
        version="1.1"
        id="svg4"
        xmlns="http://www.w3.org/2000/svg">
        <style id="style1">
          {`
            .st0 { fill: ${primaryColor}; }
            .st1 { fill: ${secondaryColor}; }
            .circle { fill: white; }
          `}
        </style>

        {/* Background circle with border */}
        <circle
          cx="50"
          cy="50"
          r="50"
          className="circle"
          id="circle1" />

        <g transform="matrix(0.8,0,0,0.8,-137,-17)" id="g4">
          <path
            className="st0"
            d="m 210.4,59.8 c 3.8,-0.5 7.3,2.1 7.9,5.9 0.5,3.8 -2.1,7.3 -5.9,7.9 -3.8,0.5 -7.3,-2.1 -7.9,-5.9 -0.5,-3.8 2.1,-7.4 5.9,-7.9 z"
          />
          <path
            className="st0"
            d="m 229.1,50.1 c -3.8,0.5 -6.4,4.1 -5.9,7.9 0.5,3.8 4.1,6.5 7.9,5.9 3.8,-0.5 6.4,-4.1 5.9,-7.9 -0.6,-3.8 -4.1,-6.5 -7.9,-5.9 z"
          />
          <path
            className="st0"
            d="m 249.7,53.5 c 3.8,-0.5 7.3,2.1 7.9,5.9 0.5,3.8 -2.1,7.3 -5.9,7.9 -3.8,0.5 -7.3,-2.1 -7.9,-5.9 -0.6,-3.8 2.1,-7.4 5.9,-7.9 z"
          />
          <path
            className="st1"
            d="m 278.1,60.4 -5.3,0.8 C 271.7,59.1 270.6,57 269.4,55 l -5.2,-8.6 c -3.3,-5.5 -9.2,-8.8 -15.6,-8.8 -14,0.1 -28,2.1 -41.5,6 v 0 c -6.1,1.8 -10.9,6.6 -12.5,12.8 l -2.6,9.7 c -0.6,2.3 -1.1,4.6 -1.5,6.9 l -5.3,0.8 c -2.1,0.3 -3.5,2.2 -3.2,4.3 0.2,1.4 1.2,2.5 2.4,3 v 0 c 0.2,0.1 0.3,0.1 0.5,0.2 l 4.4,1.4 c -0.6,8.6 0.4,20.4 2.3,28.8 l 0.2,0.7 c 1.1,4.7 5.6,7.9 10.3,7.2 l 5.9,-0.8 c 2.9,-0.4 5.4,-2.2 6.8,-4.7 1.4,-2.6 3.9,-4.3 6.8,-4.7 l 15.8,-2.3 15.8,-2.3 c 2.9,-0.4 5.8,0.6 7.8,2.6 v 0 c 2.1,2.1 5,3 7.8,2.6 l 5.9,-0.8 c 4.8,-0.7 8.2,-5 7.9,-9.8 V 98.5 C 282,89.9 279.7,78.3 276.7,70.2 l 3.8,-2.5 c 0.2,-0.1 0.3,-0.2 0.5,-0.3 v 0 c 1.1,-0.8 1.7,-2.2 1.5,-3.6 -0.4,-2.2 -2.4,-3.7 -4.4,-3.4 z m -76,37.6 c -3.8,0.5 -7.3,-2.1 -7.9,-5.9 -0.5,-3.8 2.1,-7.3 5.9,-7.9 3.8,-0.5 7.3,2.1 7.9,5.9 0.5,3.8 -2.2,7.3 -5.9,7.9 z m 54.2,-8.4 c -4.8,6.5 -11.9,10.7 -19.9,11.8 -8,1.1 -15.9,-0.9 -22.4,-5.8 -0.9,-0.7 -1.1,-2 -0.4,-2.9 0.7,-0.9 2,-1.1 2.9,-0.4 5.6,4.2 12.4,6 19.3,5 6.9,-1 13,-4.6 17.1,-10.2 0.7,-0.9 2,-1.1 2.9,-0.4 1,0.7 1.2,2 0.5,2.9 z m -49.6,-10.2 -5,0.3 c -3.7,0.3 -6.7,-3.1 -5.9,-6.8 0.4,-1.8 0.8,-3.7 1.3,-5.5 l 2.6,-9.7 c 1.2,-4.4 4.5,-7.8 8.9,-9.1 10.8,-3.1 28.8,-5.7 40.1,-5.7 v 0 c 4.5,0 8.7,2.3 11.1,6.2 l 5.2,8.6 c 1,1.6 1.9,3.2 2.7,4.9 1.7,3.3 -0.1,7.4 -3.8,8.2 l -3.7,0.8 c -17.7,3.9 -35.5,6.5 -53.5,7.8 z m 61.8,9 c -3.8,0.5 -7.3,-2.1 -7.9,-5.9 -0.5,-3.8 2.1,-7.3 5.9,-7.9 3.8,-0.5 7.3,2.1 7.9,5.9 0.5,3.9 -2.1,7.4 -5.9,7.9 z"
          />
        </g>
      </svg>
    </div>
  );
};

export default SVGComponent;
